import { ViewColumnState } from "../../../../../application-controller/store/states/view-col.states";

export interface PermissionsViewCacheState {
  clientSidePermssion: ViewColumnState;
  userPermission: ViewColumnState;
  teamPermission: ViewColumnState;
  rolePermission: ViewColumnState;
  permissionSet: ViewColumnState;
  fieldConfiguration:  ViewColumnState;
  permissionWizard: ViewColumnState;
  rolePricingSchemeLink: ViewColumnState;
  auditTrailCache: ViewColumnState;
}

export const initialState: PermissionsViewCacheState = {
  clientSidePermssion: null,
  userPermission: null,
  teamPermission: null,
  rolePermission: null,
  permissionSet: null,
  fieldConfiguration: null,
  permissionWizard: null,
  rolePricingSchemeLink: null,
  auditTrailCache: null
};
